import { Component } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { FolderOverviewService } from '../store/services'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'folder-overview-activity',
  templateUrl: './folder-overview-activity.component.html',
  styleUrls: ['./folder-overview-activity.component.scss'],
})
export class FolderOverviewActivityComponent {
  get id(): number {
    return this.folderOverviewService.folderId
  }

  constructor(
    private envService: EnvService,
    private titleService: Title,
    private folderOverviewService: FolderOverviewService
  ) {
    this.titleService.setTitle('Folder Overview | Activity')
  }

  public get baseJsUrl(): string {
    return `${this.envService.baseJsUrl}/folder-overview/${this.id}/sow-activity?sow_id=${this.id}`
  }
}
